import { render, staticRenderFns } from "./homeRecommend.vue?vue&type=template&id=51bd8087&scoped=true"
import script from "./homeRecommend.vue?vue&type=script&lang=js"
export * from "./homeRecommend.vue?vue&type=script&lang=js"
import style0 from "./homeRecommend.vue?vue&type=style&index=0&id=51bd8087&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd8087",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51bd8087')) {
      api.createRecord('51bd8087', component.options)
    } else {
      api.reload('51bd8087', component.options)
    }
    module.hot.accept("./homeRecommend.vue?vue&type=template&id=51bd8087&scoped=true", function () {
      api.rerender('51bd8087', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearch/comps/homeRecommend.vue"
export default component.exports